<template>
  <span>
    <span v-if="str.length > maxLength">
      {{ isExpand ? str : showStr }}
    </span>
    <span v-else>{{ str }}</span>
    <span
      class="ellipsis-button"
      @click="changeExpand()"
      v-if="expandable && str.length > maxLength"
    >
      {{ isExpand ? '收起' : '展开' }}
    </span>
  </span>
</template>
<script>
export default {
  name: 'Ellipsis',
  props: {
    str: {
      type: String,
      default: '',
    },
    expandable: {
      type: Boolean,
      default: false,
    },
    suffix: {
      type: String,
      default: '...',
    },
    maxLength: {
      type: Number,
      default: 20,
    },
    offset: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isExpand: false,
    };
  },
  computed: {
    showStr() {
      return `${this.str.substr(0, this.maxLength - this.offset)}${this.suffix}${this.str.substr(
        this.str.length - this.offset,
        this.str.length,
      )}`;
    },
  },
  methods: {
    changeExpand() {
      if (this.isExpand) {
        this.isExpand = false;
      } else {
        this.isExpand = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.ellipsis-button {
  color: #2f96ff;
  cursor: pointer;
}
</style>
